import { Box } from '@mui/material';
import { shallow } from 'zustand/shallow';
import type { StateAbbreviation } from '@repo/supergraph-schemas/marketplace/types';
import { useGeo } from '../../../../GeoTargeting/GeoProvider';
import { SingleSelectDropdown } from '../../../../OffersFilter/SingleSelectDropdown';
import { useFilterEvents } from '../../../../OffersFilter/useFilterEvents';
import { useOffersFilterStore } from '../store';
import { useFilterLocationOptions } from '../store/hooks';

export const LocationSelect = ({
  isStickyBar = false,
  scrollBackToMainBar,
  actionSection,
  pageIdentifier,
  isFiltersInHeader,
}: {
  isStickyBar?: boolean;
  scrollBackToMainBar?: () => void;
  actionSection: string;
  pageIdentifier: string;
  isFiltersInHeader?: boolean;
}) => {
  const locationOptions = useFilterLocationOptions();
  const { regionCode, setRegionCode } = useGeo();
  const { handleUpdateFilterFormState, handleApplyFilters, appliedFilters } = useOffersFilterStore(
    ({ handleUpdateFilterFormState, handleApplyFilters, appliedFilters }) => ({
      handleUpdateFilterFormState,
      handleApplyFilters,
      appliedFilters,
    }),
    shallow,
  );

  const { updateFiltersEvent } = useFilterEvents({
    actionSection,
    pageIdentifier,
    additionalAttributes: {},
  });

  const handleLocationChange = (selectedLocation: string) => {
    if (scrollBackToMainBar) {
      scrollBackToMainBar();
    }

    setTimeout(
      () => {
        handleUpdateFilterFormState({
          selectedLocation: selectedLocation,
        });

        setRegionCode(selectedLocation as StateAbbreviation);

        const newState = handleApplyFilters();
        if (!newState) return;

        updateFiltersEvent({
          additional_attributes: {
            location: selectedLocation,
            product_types: newState.appliedFilters.selectedProductTypes,
          },
        });
      },
      scrollBackToMainBar ? 100 : 0,
    );
  };

  const selectedLocation = appliedFilters?.selectedLocation ?? regionCode;

  return (
    <Box sx={{ minWidth: '200px' }}>
      <SingleSelectDropdown
        isStickyBar={isStickyBar}
        label="Location"
        options={locationOptions}
        selectedOption={selectedLocation}
        onChange={handleLocationChange}
        useStore={useOffersFilterStore}
        placeholder="Location"
        isFiltersInHeader={isFiltersInHeader}
      />
    </Box>
  );
};
